import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SettingsService } from 'src/app/core/settings/settings.service';
import { ZipcodeService } from '../zipcode.service';
import { UserLogin } from 'src/app/ceq/common/models/UserLogin.Model';
import { ZipCodeModel } from 'src/app/ceq/common/models/ZipCode.Model';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-zipcode-detail',
  templateUrl: './zipcode-detail.component.html',
  styleUrls: ['./zipcode-detail.component.scss']
})
export class ZipcodeDetailComponent implements OnInit {

  userLogin: UserLogin;
  zipCode: ZipCodeModel = new ZipCodeModel();
  isNew: boolean = false;

  constructor(
    private url: ActivatedRoute,
    private router: Router,
    private settings: SettingsService,
    private globalFunctionService: GlobalFunctionsService,
    private zipcodeService: ZipcodeService
  ) { }

  ngOnInit(): void {
    this.userLogin = this.settings.getUser();
    const currentId = this.url.snapshot.paramMap.get('id');

    this.zipCode.Org = this.userLogin.Org;

    if (this.isNullOrWhitespace(currentId) || currentId === 'create') {
      this.zipCode.IdZipCode = "";
      this.isNew = true;
    } else {
      this.zipCode.IdZipCode = currentId;
      this.isNew = false;
      this.getZipCode();
    }
  }

  getZipCode() {
    this.zipcodeService.getZipCodeById(this.zipCode.Org, this.zipCode.IdZipCode).subscribe({
      next: (data) => {
        if (data) this.zipCode = data;
      },
      error: async () => {
        await this.globalFunctionService.messageBimbo("No se encontró el código postal solicitado", 'error', '¡Error!');
        this.btnCancelOnClick();
      }
    });
  }

  formSubmit() {
    const operation = this.isNew 
      ? this.zipcodeService.createZipCode(this.zipCode)
      : this.zipcodeService.updateZipCode(this.zipCode);

    operation.subscribe({
      next: async () => {
        const msg = this.isNew ? 'Código postal creado' : 'Código postal actualizado';
        await this.globalFunctionService.messageBimbo(msg, 'success', '¡Éxito!');
        this.btnCancelOnClick();
      },
      error: async (err) => {
        const errorMsg = err.error || 'Ocurrió un error al guardar';
        await this.globalFunctionService.messageBimbo(errorMsg, 'error', '¡Error!');
      }
    });
  }

  btnCancelOnClick() {
    this.router.navigate(['/tax/zipcode']);
  }

  private isNullOrWhitespace(input: any): boolean {
    return !input || input.toString().trim().length < 1;
  }
}